export default __webpack_public_path__ + "static/media/ico-check-blue.8e9929de.svg";